module.exports = __webpack_public_path__ + "img/logo.ccd2780d.png";